import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  return (
    <Page
      title='Feature Flags Settings'
      breadcrumbs={[
        {
          label: 'History',
        },
        {
          label: 'Feature Flags Settings',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/settings/feature-flags',
  component: RouteComponent,
  type: 'auth',
  locationRequired: true,
});
